var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ion-button',{attrs:{"disabled":!_vm.$store.state.online_status},on:{"click":_vm.addFixture}},[_c('ion-icon',{attrs:{"name":"add"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }